// Русские названия проверок для админки.
//
// Дубль локали кабинета, и это осознанно: админка не переводится (в pages/admin текст
// пишется прямо в JSX, без t() и файлов локалей), а дежурному нужны человеческие
// названия, а не коды вроде products_fiscal_code. Источник правды по текстам —
// src/locales/ru.json, ключи setup_health_check_* / setup_health_fix_*: добавили проверку
// туда — продублируйте сюда, иначе в админке останется голый код.

export const CHECK_TITLES = {
	check_failed: "Проверка не выполнена",
	service_enabled: "Услуга «Фискализация» подключена",
	pos_tin: "ИНН точки заполнен",
	terminal: "Фискальный терминал заведён",
	terminal_provider: "Выбран провайдер фискализации",
	terminal_serial: "Указан серийный номер фискального модуля",
	payment_type_fiscal: "Тип оплаты помечен фискальным",
	products_fiscal_code: "У товаров заполнены МХИК и код упаковки",
	products_tax_category: "У товаров указана налоговая категория",
	driver: "Фискальный драйвер отвечает",
	ofd_connection: "Касса достаёт до серверов налоговой",
	ofd_connection_unsupported: "Касса достаёт до серверов налоговой",
	z_report: "Смена в ОФД открыта",
	cheques_fiscalized: "Чеки уходят в ОФД",
	pos_online: "Касса на связи",
	printers: "Принтеры отвечают",
	printers_unassigned: "Все принтеры из сети заведены в системе",
	devices: "Весы и камеры доступны",
	attendance: "Отметки с камеры попадают в учёт",
	client_version: "Версия программы кассы",
	last_sync: "Касса синхронизируется с облаком",
	credentials: "Ключи доступа заполнены",
	poses: "Интеграция привязана к точке",
	external_group: "Внешнее меню привязано",
	categories: "В меню есть включённые категории",
	items_sent: "Позиции уходят агрегатору",
	items_blocked: "Все позиции доходят до витрины",
	payment_type: "Тип оплаты выбран",
	order_type: "Тип заказа выбран",
	auto_payment: "Контрагент для автооплаты указан",
	orders_received: "Заказы приходят",
	token: "Ключ курьерской службы заполнен",
	courier_poses: "Служба привязана к точке",
	pos_coordinates: "Точка отмечена на карте",
	pos_phone: "Телефон точки заполнен",
	pos_address: "Адрес точки заполнен",
	catalog_categories: "В витрине есть категории",
	catalog_products: "В витрине есть товары",
	catalog_blocked: "Все позиции видны гостю",
	catalog_stop_list: "Стоп-лист пуст",
	catalog_stop_list_online: "Онлайн стоп-лист включён",
	catalog_images: "У позиций есть фото",
	catalog_prices: "У позиций заполнены цены",
	channel_active: "Канал включён",
	channel_credentials: "Доступ настроен",
	channel_poses: "Канал привязан к точке",
	channel_order_type: "Тип заказа выбран",
	channel_payment_type: "Тип оплаты выбран",
	channel_orders_received: "Заказы приходят",
	sms_provider: "SMS-провайдер подключён",
	sms_credentials: "Ключи провайдера заполнены",
	sms_balance: "На балансе есть деньги",
	sms_routes: "Есть включённые SMS-события",
	base_menu: "Категории меню заведены",
	base_products: "Товары заведены",
	base_products_price: "У товаров заполнены цены",
	base_cashiers: "Кассиры заведены",
	base_payment_types: "Типы оплат настроены",
	base_cashbox: "Касса и её счета настроены",
	base_wms: "Склад заведён",
	base_suppliers: "Поставщики заведены",
	base_preparation_places: "Места приготовления заведены",
	base_print_routes: "Маршруты печати настроены",
	base_halls: "Залы и столы заведены",
	again: "Проверить заново",
	driver_not_configured: "Фискализация включена на кассе",
	z_report_unsupported: "Смена в ОФД открыта",
	pos_clock: "Часы кассы идут верно",
	shift_open: "Кассовая смена",
	pending_cheques: "Все чеки доехали до облака",
	printers_count: "Принтеры отвечают",
	shift_unsupported: "Кассовая смена"
}

export const CHECK_HINTS = {
	check_failed: "Не удалось выполнить проверку. Попробуйте обновить страницу",
	service_enabled: "Услуга не подключена — обратитесь в поддержку",
	pos_tin: "ИНН не заполнен — он не будет напечатан в чеке. В ОФД уходит ИНН из фискального модуля",
	terminal: "На точке нет фискального терминала — добавьте его в разделе «Терминалы»",
	terminal_provider: "У терминала не выбран провайдер (Soliq V1 или V2)",
	terminal_serial: "Не указан серийный номер фискального модуля",
	payment_type_fiscal: "Ни один тип оплаты не помечен фискальным — чеки не пойдут в ОФД",
	products_fiscal_code: "Товаров без МХИК или кода упаковки: {{count}}. Чек с такой позицией не пробьётся целиком",
	products_tax_category: "Товаров без налоговой категории: {{count}} — НДС уйдёт нулевым",
	driver: "Драйвер на кассе не отвечает — проверьте, запущен ли он",
	ofd_connection: "С кассы нет связи с серверами налоговой: {{description}}. Чеки не уйдут в ОФД, а когда истечёт срок их хранения, фискальный модуль заблокирует кассу. Обычный интернет при этом может работать — проверьте роутер, антивирус и провайдера на точке",
	z_report: "Смена в ОФД закрыта — откройте кассу на кассовом компьютере",
	cheques_fiscalized: "За неделю в ОФД не ушло ни одного чека ({{count}}) — проверьте фискальный драйвер на кассе",
	pos_online: "Касса давно не отвечала — данные об оборудовании могли устареть",
	printers: "Не отвечают {{count}} из {{total}}: {{description}} — проверьте питание и сеть",
	printers_unassigned: "В сети найдены принтеры, не заведённые в системе: {{count}}",
	devices: "Не отвечают {{count}} из {{total}}: {{description}}",
	last_sync: "Касса не синхронизировалась больше суток — отчёты в кабинете будут неполными",
	credentials: "Не заполнены ключи интеграции — агрегатор не сможет к нам подключиться",
	poses: "Интеграция не привязана ни к одной точке — заказы приходить не будут",
	external_group: "Внешнее меню не привязано или удалено — агрегатор получает пустой список",
	categories: "Во внешнем меню нет ни одной включённой категории",
	items_sent: "Ни одна позиция не уходит агрегатору",
	items_blocked: "Не уходят позиций: {{count}}",
	payment_type: "Тип оплаты не выбран или удалён — заказ не закроется",
	order_type: "Тип заказа не выбран или удалён",
	auto_payment: "Включена автооплата, но не выбран контрагент — деньги агрегатора не разнесутся",
	orders_received: "Заказов нет уже {{count}} дн. — проверьте, работает ли точка у агрегатора",
	token: "Не заполнен ключ службы — вызвать курьера не получится",
	courier_poses: "Курьерская служба не привязана к этой точке",
	pos_coordinates: "Не заданы координаты точки — заявка курьеру не отправится",
	pos_phone: "Телефон точки не заполнен или указан неверно — нужен формат 998901234567",
	pos_address: "Не заполнен адрес точки — курьеру будет сложно найти вход",
	catalog_categories: "Ни одна категория не помечена для внешнего меню — бот и сайт откроются пустыми",
	catalog_products: "Ни один товар не помечен для внешнего меню — гостю нечего заказать",
	catalog_blocked: "Не видны гостю позиций: {{count}}",
	catalog_stop_list: "В стоп-листе позиций: {{count}} — гость их не купит",
	catalog_stop_list_online: "Онлайн стоп-лист выключен — снятые на кассе позиции продолжат продаваться в боте и у агрегатора",
	catalog_images: "Без фото позиций: {{count}} — такие берут заметно реже",
	catalog_prices: "С нулевой ценой позиций: {{count}}",
	channel_active: "Канал выключен — гости его не видят",
	channel_credentials: "Не заполнен токен бота или домен сайта",
	channel_poses: "Канал не привязан ни к одной точке",
	channel_order_type: "Не выбран тип заказа — заказ не на что положить",
	channel_payment_type: "Тип оплаты не выбран или удалён",
	channel_orders_received: "Заказов из этого канала пока не было",
	sms_provider: "SMS-провайдер не подключён — сообщения гостям не уходят",
	sms_credentials: "Не заполнены поля провайдера: {{description}}",
	sms_balance: "Баланс точки закончился — отправка SMS остановлена",
	sms_routes: "Ни одно событие не отправляет SMS — провайдер настроен впустую",
	base_menu: "Нет ни одной категории меню",
	base_products: "Нет ни одного товара",
	base_products_price: "Без цены товаров: {{count}}",
	base_cashiers: "На точке нет кассира — смену на кассе открыть будет некому",
	base_payment_types: "Нет ни одного типа оплаты, видимого на кассе",
	base_cashbox: "Касса не заведена или у неё не выбраны счета — деньги смены некуда положить",
	base_wms: "Нет ни одного склада — принять приход будет некуда",
	base_suppliers: "Нет ни одного поставщика",
	base_preparation_places: "Нет мест приготовления — кухня не получит заказ",
	base_print_routes: "Нет маршрутов печати — кухонные марки печататься не будут",
	base_halls: "Зал есть, но в нём нет столов — официант не сможет открыть заказ",
	driver_not_configured: "Касса не знает о фискализации: в её терминале не выбран провайдер, хотя в кабинете он указан. Сделайте синхронизацию на кассе",
	pos_clock: "Часы кассы разошлись с сервером на {{description}} — чеки уедут не в тот день",
	shift_open: "Смена открыта {{count}} дн. назад и не закрыта — выручка уедет не в тот день",
	pending_cheques: "Чеков ещё не доехало: {{count}} — отчёты в кабинете будут неполными"
}

export const CHECK_SKIPPED = {
	service_enabled: "Услуга не подключена, остальные проверки не выполняются",
	products_tax_category: "Точка не платит НДС — проверка не нужна",
	driver: "Касса не ответила — проверьте, включена ли она",
	ofd_connection: "Касса не ответила — проверьте, включена ли она",
	ofd_connection_unsupported: "Версия программы кассы не проверяет связь с налоговой — обновите кассу",
	z_report: "Касса не ответила — проверьте, включена ли она",
	cheques_fiscalized: "За неделю чеков не было",
	pos_online: "Касса не ответила",
	printers: "Касса не ответила",
	printers_unassigned: "Касса не ответила",
	devices: "Касса не ответила",
	client_version: "Касса не ответила",
	last_sync: "Синхронизаций не было",
	auto_payment: "Автооплата выключена",
	orders_received: "Интеграция создана недавно, заказов ещё не было",
	catalog_stop_list_online: "Стоп-лист не используется",
	channel_credentials: "Каналу отдельный доступ не нужен",
	channel_order_type: "У этого канала свои типы заказа",
	channel_payment_type: "Оплата настраивается отдельно",
	channel_orders_received: "Канал не принимает заказы",
	sms_provider: "Провайдер не подключён",
	sms_credentials: "Свой провайдер — ключи не нужны",
	sms_balance: "Оплата идёт напрямую оператору",
	sms_routes: "Провайдер не подключён",
	base_halls: "Заведение работает без зала",
	z_report_unsupported: "Драйвер {{description}} не сообщает состояние смены — смотрите на кассе",
	pos_clock: "Касса не сообщила своё время",
	shift_open: "Касса не сообщила состояние смены",
	pending_cheques: "Касса не сообщила очередь",
	shift_unsupported: "Версия кассы {{description}} ещё не сообщает состояние смены — обновите программу кассы"
}

// {{count}} и {{description}} приходят из локали — подставляем их из самой проверки
export function checkTitle(check) {
	return CHECK_TITLES[check.code] || check.code
}

export function checkHint(check) {
	const source = check.status === 'skipped'
		? CHECK_SKIPPED[check.code]
		: CHECK_HINTS[check.code]

	if (!source) return check.description || ''

	return source
		.replace(/{{count}}/g, check.count ?? 0)
		.replace(/{{description}}/g, check.description || '')
}

// Сводные проблемы точки (adminProblemRows на бэке) — общие для «Диагностики точек»
// и корзины «Проблемы настройки» в «Заботе о клиентах»
export const PROBLEM_TITLES = {
	fiscal_no_terminal: 'Фискализация без терминала',
	delivery_without_menu: 'Интеграция без внешнего меню',
	courier_without_coordinates: 'Курьерка без координат точки',
	catalog_empty: 'Пустая витрина бота и сайта',
	no_staff: 'Нет кассиров и официантов',
}
